import { render, staticRenderFns } from "./Savings.vue?vue&type=template&id=574a85f1&scoped=true&"
import script from "./Savings.vue?vue&type=script&lang=js&"
export * from "./Savings.vue?vue&type=script&lang=js&"
import style0 from "./Savings.vue?vue&type=style&index=0&id=574a85f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574a85f1",
  null
  
)

export default component.exports